<script lang="ts">
  import FilterForm from "./FilterForm.svelte";
  import type { Accordion, FilterFormProps } from "./FilterFormTypes";

  interface Props {
    accordion: Accordion;
    form: FilterFormProps;
  }

  const { accordion, form }: Props = $props();

  const inlineAccordionClass = [
    accordion.alwaysInline ? "heureka_inlineFilter" : "",
    "heureka_filterAccordion--ocComponents",
    "heureka_filterAccordion",
    accordion.inlineInSheet ? "heureka_filterAccordion--openOnMobile" : "",
    accordion.hasExplanatoryText ? "heureka_filterAccordion--explanatoryText" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const regularAccordionClass = [
    accordion.alwaysInline ? "heureka_inlineFilter" : "",
    "heureka_filterAccordion--ocComponents",
    "heureka_filterAccordion",
    "heureka_filterAccordion--regular",
    accordion.inlineInSheet ? "heureka_filterAccordion--openOnMobile" : "",
    accordion.hasExplanatoryText ? "heureka_filterAccordion--explanatoryText" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const contentClass = `heureka_filterAccordion__content ${accordion.contentClasses ?? ""}`.trim();
</script>

{#if accordion.alwaysInline}
  <oc-row-v2
    style="--custom-spacing-y: var(--oc-semantic-spacing-75)"
    {...accordion.hideDivider ? { "hide-divider": "" } : {}}
    hidden={accordion.hidden}
  >
    <div class={inlineAccordionClass} data-filter-id={accordion.filterId} data-filter-title={accordion.filterTitle}>
      <dt class={contentClass}>
        <FilterForm {...form} />
      </dt>
    </div>
  </oc-row-v2>
{:else}
  <oc-row-v2
    style="--custom-spacing-y: var(--oc-semantic-spacing-0)"
    {...accordion.hideDivider ? { "hide-divider": "" } : {}}
    hidden={accordion.hidden}
  >
    <oc-accordion-v1
      class={regularAccordionClass}
      data-filter-id={accordion.filterId}
      data-filter-title={accordion.filterTitle}
      title={accordion.filterTitle}
      hide-divider
      {...accordion.open ? { expanded: "" } : {}}
    >
      <div class="heureka_filterHeaderButtons heureka_filterHeaderButtons--hidden">
        {#if accordion.removeTrashcan}
          <oc-link-v2 class="heureka_filterTitle__more" size="100">
            <span class="heureka_filterTitle__more--label"
              >Alle<oc-icon-v1
                class="heureka_filterTitle__more--icon"
                type="arrow-right"
                size="100"
                color="var(--oc-semantic-color-text-interactive)"
              ></oc-icon-v1></span
            >
          </oc-link-v2>
        {:else}
          <oc-icon-button-v3
            data-ts-feature-labels={accordion.deselectFilterTracking.labelsJson}
            class="heureka_removeAllTrashCan ts_heureka_selectAll"
            data-select-mode="deselect"
            form={`find_filter_${accordion.deselectFilterTracking.id}`}
            {...accordion.selected ? {} : { hidden: "" }}
            icon="delete"
            variant="secondary-over-color"
            size="75"
            icon-color="var(--oc-semantic-color-text-secondary)"
          ></oc-icon-button-v3>
        {/if}
      </div>
      <div class={contentClass}>
        <FilterForm {...form} />
      </div>
    </oc-accordion-v1>
  </oc-row-v2>
{/if}
